import { Burger, Group, Menu, Stack, Text } from '@mantine/core';
import { IconChevronDown, IconLogout } from '@tabler/icons-react';
import { useAuth } from '@/hooks/useAuth';
import styles from './Header.module.sass';
import { Navigation } from '@/components/Navigation';

export const Header = () => {
  const { userInfo, logout } = useAuth();

  const LAYOUT = {
    USER_MENU_WIDTH: 200,
    ICON_SIZE: 16,
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <Stack className={styles.headerContainer} gap={0} justify="space-between">
      <Group justify="space-between" px="md" py="xs" className={styles.header}>
        <Group>
          <Burger size="sm" color={'gray.0'} />
          <Text className={styles.title}>DIGITAL PRODUCTS ADMIN</Text>
        </Group>
        <Menu shadow="md" width={LAYOUT.USER_MENU_WIDTH}>
          <Menu.Target>
            <Group gap="xs" className={styles.userMenuTrigger} px="sm" py="xxs">
              <Text className={styles.userName}>{userInfo?.profile?.name || 'User'}</Text>
              <IconChevronDown size={LAYOUT.ICON_SIZE} />
            </Group>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item leftSection={<IconLogout size={LAYOUT.ICON_SIZE} />} color="red" onClick={handleLogout}>
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <Navigation />
    </Stack>
  );
};
